import PropTypes from 'prop-types';
import VariantSelectorContainer from '@sportson/core-web/containers/VariantSelectorContainer';
import ProductVariants from 'components/productPage/Variants/ProductVariants';

export const ProductVariantSelector = ({
    callback,
    variants,
    selectedVariant,
    productId,
    layout,
    getSelectedParametrics,
    ...props
}) => (
    <VariantSelectorContainer
        callback={callback}
        getSelectedParametrics={getSelectedParametrics}
        variants={variants}
        productId={productId}
        selectedVariant={selectedVariant}
        render={({
            checkPossibleSelection,
            checkStockStatus,
            getVariantByParametricSelection,
            selectedParametrics,
            selections,
            selectParametricValue,
        }) => (
            <ProductVariants
                checkPossibleSelection={checkPossibleSelection}
                checkStockStatus={checkStockStatus}
                getVariantByParametricSelection={getVariantByParametricSelection}
                layout={layout}
                selectedParametrics={selectedParametrics}
                selectedVariant={selectedVariant}
                selectParametricValue={selectParametricValue}
                variants={selections}
                {...props}
            />
        )}
    />
);

ProductVariantSelector.propTypes = {
    callback: PropTypes.func.isRequired,
    getSelectedParametrics: PropTypes.func,
    layout: PropTypes.string,
    productId: PropTypes.number.isRequired,
    selectedVariant: PropTypes.object,
    variants: PropTypes.array.isRequired,
};

ProductVariantSelector.defaultProps = {
    getSelectedParametrics: () => null,
    layout: 'blocks',
    selectedVariant: null,
};
